import React from "react";
import PageHero from "../components/PageHero";

export default function Privacy() {
  return (
    <div>
      <PageHero title="Privacy Policy" breadcrumb="Privacy Policy" subtitle="Aapki privacy hamari priority hai. Yahan padhein hum kaise aapka data collect, use aur protect karte hain. Last updated: 24 June 2026." />
      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card-dark p-6 md:p-9 space-y-6 text-slate-300 leading-relaxed text-[15px]">
            <section>
              <h2 className="text-xl font-bold text-white">1. Information We Collect</h2>
              <p className="mt-2">Hum sirf wahi data collect karte hain jo aap khud humein dete hain (jaise naam, WhatsApp number, email) ya jo automatically capture hota hai (browser type, device info, anonymous analytics).</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">2. How We Use Your Data</h2>
              <ul className="list-disc pl-6 space-y-1.5 mt-2">
                <li>Cricket ID provision aur related communication ke liye</li>
                <li>Customer support aur query resolution ke liye</li>
                <li>Service improvement aur fraud prevention ke liye</li>
                <li>Important policy ya legal updates inform karne ke liye</li>
              </ul>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">3. Data Sharing</h2>
              <p className="mt-2">Hum aapka personal data kisi bhi third-party advertiser ya marketing company ke saath share nahi karte. Sirf zaruri partners (exchange platforms, payment gateways) ke saath sirf necessary information share hoti hai.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">4. Security</h2>
              <p className="mt-2">Hamari website SSL encrypted hai. Industry-standard security practices use karke hum aapka data protect karte hain. Lekin koi bhi online service 100% breach-proof nahi hoti - hum continuously security improve karte rehte hain.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">5. Cookies</h2>
              <p className="mt-2">Website essential cookies use karti hai user experience improve karne ke liye. Aap browser settings se cookies disable kar sakte hain, lekin kuch features properly kaam nahi karenge.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">6. Your Rights</h2>
              <p className="mt-2">Aap kabhi bhi apna data access, correct ya delete karva sakte hain. Bas WhatsApp par message bhejein ya email karein support@onlinecricketid.guru par.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">7. Children's Privacy</h2>
              <p className="mt-2">OnlineCricketID.guru 18 saal se kam umar wale users ke liye nahi hai. Hum knowingly minors ka data collect nahi karte. Agar pata chala to data turant delete kiya jata hai.</p>
            </section>
            <section>
              <h2 className="text-xl font-bold text-white">8. Policy Updates</h2>
              <p className="mt-2">Yeh policy time-to-time update ho sakti hai. Significant changes par hum users ko notify karenge. Last updated date upar mentioned hai.</p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
}
